<script setup>
import { ref, onMounted } from "vue";
import { useSettingsStore } from "@/stores/storeSettings";

const storeSettings = useSettingsStore();
const faqActive = ref({});
const dataFaq = ref({});
const offset = ref(0);
const limit = 5;

const openFaqItem = (index) => {
    const newActive = {}
    for(let i = 0; i < dataFaq.value?.results.length; i++) {
        newActive[i] = i === index ? !faqActive.value[index] : false;
    }
    faqActive.value = newActive;
}

const showMore = async () => {
	offset.value += limit;
	const data = await storeSettings.getFaq(offset.value, limit);
	dataFaq.value.results.push(...data.results);
	dataFaq.value.next = data.next;			
}

const formatText = (text) => {
	let formattedText = text.replace(/\r?\n/g, "<br>");

	const urlPattern = /(?<!<a href=")(https?:\/\/[^\s]+)(?!")/g;

	formattedText = formattedText.replace(urlPattern, '<a href="$1" target="_blank">$1</a>');

	return formattedText;
};

onMounted(async () => {
	dataFaq.value = await storeSettings.getFaq(offset.value, limit);
});
</script>
<template>
	<section class="faq section">
		<div class="section__inner">
			<div class="faq__container">
				<div class="faq__content">
					<h2 class="faq__title title">FAQ</h2>
					<ul class="faq__info-list">
						<li class="faq__info-item">
							<h6 class="faq__info-title">Оcтались вопросы?</h6>
						</li>
						<li class="faq__info-item">
							<p class="faq__info-desc">Свяжитесь с нашим отделом поддержки</p>
						</li>
						<li class="faq__info-item">
							<a :href="`tel:${storeSettings.contactsPhone}`" class="faq__info-link">
								<svg width="40" height="40"><use href="#phone_border"></use></svg>
								<span>{{ storeSettings.contactsPhone }}</span>
							</a>
							<a :href="`mailto:${storeSettings.contactsEmail}`" class="faq__info-link">
								<svg width="40" height="40"><use href="#mail_border"></use></svg>
								<span>{{ storeSettings.contactsEmail }}</span>
							</a>
						</li>
						<li class="faq__info-item">
							<a :href="storeSettings.contactsTelegram" target="_blank" rel="noopener noreferrer" class="faq__info-link-social">
								<svg width="40" height="40"><use href="#telegram"></use></svg>
							</a>
							<a :href="storeSettings.contactsWhatsapp" target="_blank" rel="noopener noreferrer" class="faq__info-link-social">
								<svg width="40" height="40"><use href="#wa"></use></svg>
							</a>
						</li>
					</ul>
				</div>
				<ul v-if="dataFaq.results?.length" class="faq__list">
					<li :class="['faq__item', { active: faqActive[index] }]" v-for="(faq, index) in dataFaq.results" :key="index" @click="openFaqItem(index)">
						<div class="faq__question">
							{{ faq.question }}
							<div class="faq__btn"></div>
						</div>
						<div class="faq__answer">
							<div style="min-height: 0" v-html="formatText(faq.answer)"></div>
						</div>
					</li>
					<button v-if="dataFaq.next" @click="showMore" class="faq__list-btn btn">Показать ещё</button>
				</ul>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.faq {
	--faq-padding-top: 8rem;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
	@media (max-width: vars.$x480) {
		--faq-padding-top: 4rem;
	}
}
.section__inner {
	overflow: clip;
}
.faq__container {
	display: grid;
	grid-template-columns: 31% 1fr;
	align-items: start;
	@media (max-width: vars.$m) {
		grid-template-columns: 1fr;
	}
}
.faq__content {
	font-family: var(--second-family);
	position: sticky;
	top: 2rem;
	padding-top: var(--faq-padding-top);
	padding-left: var(--padding-container);
	padding-right: 12.5rem;
	padding-bottom: 2rem;
	@media (max-width: vars.$t) {
		padding-right: 5rem;
	}
	@media (max-width: vars.$m) {
		position: static;
	}
	@media (max-width: vars.$x480) {
		padding-bottom: 3rem;
	}
}

.faq__title {
	margin-bottom: 1.7rem;
}
.faq__info-list {
	display: grid;
	gap: 3.3rem;
	@media (max-width: vars.$x480) {
		gap: 1.4rem;
	}
}
.faq__info-item {
	&:last-child {
		display: flex;
		gap: 0.2rem;
	}
}
.faq__info-title {
	font-weight: 700;
	font-size: 2.4rem;
	line-height: 140%;
	@media (max-width: vars.$x480) {
		font-size: 2rem;
	}
}
.faq__info-desc {
	font-weight: 400;
	font-size: 2rem;
	line-height: 160%;
	color: var(--text-inverse-72);
	@media (max-width: vars.$x480) {
		font-size: 1.4rem;
	}
}
.faq__info-link {
	display: flex;
	align-items: center;
	gap: 2rem;
	& + .faq__info-link {
		margin-top: 16px;
	}
	@media (hover: hover) {
		&:hover {
			span {
				border-color: inherit;
			}
		}
	}
	span {
		font-weight: 700;
		font-size: 2rem;
		line-height: 160%;
		border-bottom: 1px solid transparent;
		text-wrap: nowrap;
		white-space: nowrap;
		transition: border-color var(--transition) ease-in;
	}
	svg {
		width: 4rem;
		height: 4rem;
	}
}
.faq__info-link-social {
	display: flex;
	align-items: center;
	justify-content: center;
	// padding: 1.6rem;
	flex-shrink: 0;
	border: 1px solid transparent;
	svg {
		stroke: transparent;
		stroke-width: 0;
		width: 4rem;
		height: 4rem;
		transition: var(--transition) ease-in;
	}
	@media (hover: hover) {
		&:hover {
			border: 1px solid var(--border-default-1);
			background: var(--fill-inverse-3);
		}
	}
	&:active {
		border: 1px solid var(--border-default-1);
		background: var(--system-fill-dark);
	}
	& + .faq__info-link-social {
		margin-left: 1rem;
	}
}

.faq__list {
	display: grid;
	gap: 0.8rem;
	background: var(--brand-accent-1-100);
	padding-top: var(--faq-padding-top);
	padding-right: var(--padding-container);
	padding-left: 7rem;
	padding-bottom: 2rem;
	// height: 100%;
	@media (max-width: vars.$t) {
		padding-left: 3rem;
	}
	@media (max-width: vars.$m) {
		padding-left: var(--padding-container);
	}
	@media (max-width: vars.$x480) {
		padding-top: 7rem;
		padding-bottom: 5rem;
	}
}
.faq__item {
	padding: 3rem 0rem;
	border-bottom: 1px solid rgba(255, 255, 255, 0.05);
	@media (max-width: vars.$x480) {
		padding: 2rem 0rem;
	}
	&:first-child {
		padding-top: 0;
	}
	&.active {
		.faq__btn {
			&::after {
				transform: rotate(90deg) translateX(0.1px);
			}
		}
		.faq__answer {
			grid-template-rows: 1fr;
			padding-top: 1.6rem;
			padding-bottom: 0.8rem;
		}
	}
	// @media (hover: hover){
	//     &:hover {
	//         .faq__btn {
	//             background: var(--color-fill-tretiary);
	//             &::before {
	//                 background-color: var(--color-brand-aubergine);
	//             }
	//             &::after {
	//                 background-color: var(--color-brand-aubergine);
	//             }
	//         }
	//     }
	// }
}
.faq__question {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	font-family: var(--font-family);
	font-weight: 800;
	font-size: 3.2rem;
	line-height: 125%;
	cursor: pointer;
	@media (max-width: vars.$x480) {
		font-size: 1.7rem;
	}
}
.faq__btn {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 5.6rem;
	height: 5.6rem;
	background: var(--color-fill-secondary);
	transition: background var(--transition) ease-in;
	@media (max-width: vars.$x480) {
		width: 3.2rem;
		height: 3.2rem;
	}
	&::before {
		position: absolute;
		content: "";
		background-color: var(--text-inverse-100);
		width: 3.6rem;
		height: 0.2rem;
		border-radius: 1rem;
		@media (max-width: vars.$x480) {
			width: 2.1rem;
			height: 0.1rem;
		}
	}
	&::after {
		position: absolute;
		content: "";
		background-color: var(--text-inverse-100);
		width: 0.2rem;
		height: 3.6rem;
		border-radius: 1rem;
		transition: transform var(--transition) ease-in;
		@media (max-width: vars.$x480) {
			width: 0.1rem;
			height: 2.1rem;
		}
	}
}
.faq__answer {
	font-family: var(--second-family);
	font-weight: 400;
	font-size: 2rem;
	line-height: 130%;

	display: grid;
	grid-template-rows: 0fr;
	overflow: hidden;
	transition: 0.3s ease-in-out;

	@media (max-width: vars.$x480) {
		font-size: 1.6rem;
	}
}
.faq__list-btn {
	width: 100%;
	margin: 3rem 0;
	@media (max-width: vars.$x480) {
		margin: 1rem 0 0;
	}
}
</style>
@/stores/storeSettings
